import { Asset } from 'interfaces';

export const getAssetName = (assetsPayloads: any[], id: string): string => {
  const asset = assetsPayloads.filter((asset: Asset) => asset.id === id)[0];

  return asset?.name || id;
};
